export * from './lib/pages.module';
